import base from '../base'
import { postJsonRequest, postRequest, blobJsonRequest, blobGetRequest } from '@utils/request'

const cloud = `prescription/${base.appCode}`

const PHARMACYMANAGE = {

  // 查询医院列表
  querySelectHospitalList(params = {}) {
    params.appCode = base.appCode
    return postRequest(`${base.baseUrl}/${cloud}/api/pharmaceuticalCompany/manage/selectHospitalList`, params)
  },

  // 添加药商
  addPharmacist(params = {}) {
    params.appCode = base.appCode
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/pharmaceuticalCompany/manage/addPharmacist`, params)
  },

  // 查询药商
  getPharmacist(params = {}) {
    params.appCode = base.appCode
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/pharmaceuticalCompany/manage/selectPharmacistById`, params)
  },

  // 获取药商列表(分页)
  queryPharmacistList(params = {}) {
    params.query.appCode = base.appCode
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/pharmaceuticalCompany/manage/pharmacistList`, params)
  },

  // 删除药商
  deletePharmacist(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/pharmaceuticalCompany/manage/deletePharmacist`, params)
  },

  // 修改药商
  updatePharmacist(params = {}) {
    params.appCode = base.appCode
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/pharmaceuticalCompany/manage/updatePharmacist`, params)
  },

  // 获取全部药商
  queryAllPharmacist(params = {}) {
    params.appCode = base.appCode
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/pharmaceuticalCompany/manage/paginglist`, params)
  },

  // 权限-获取全部药商
  getAuthAllPharmacist(params = {}) {
    params.appCode = base.appCode
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/drugStore/manage/store/filter/pharmacistList`, params)
  },

  // 查询药师
  querySelectDoctor(params = {}) {
    params.appCode = base.appCode
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/drugStore/manage/selectDoctor`, params)
  },

  // 保存药房
  saveDrugStore(params = {}) {
    params.appCode = base.appCode
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/drugStore/manage/saveDrugStore `, params)
  },

  // 药房列表
  drugStoreList(params = {}) {
    params.query.appCode = base.appCode
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/drugStore/manage/drugStoreList`, params)
  },

  // 删除药房
  deleteDrugStore(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/drugStore/manage/deleteDrugStore`, params)
  },

  // 药房上下线
  updateOnlineStatus(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/drugStore/manage/updateOnlineStatus`, params)
  },

  // 查询药房详情
  selectDrugStoreById(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/drugStore/manage/selectDrugStore`, params)
  },

  // 查询服药方式
  queryTakeMethods(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/drugItem/manage/findDrugUsage`, params)
  },

  // 根据type查询药品单位
  findDrugUnitByType(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/drugItem/manage/findDrugUnitByType`, params)
  },

  // 保存药品
  saveDrugIteam(params = {}) {
    params.appCode = base.appCode
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/drugItem/manage/saveDrugItem`, params)
  },

  // 获取药品列表
  drugIteamList(params = {}) {
    params.query.appCode = base.appCode
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/drugItem/manage/drugItemList`, params)
  },

  // 权限-获取药品列表
  getAuthDrugList(params = {}) {
    params.query.appCode = base.appCode
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/drugItem/manage/drugItemList`, params)
  },

  // 查询药品详情
  queryDrugById(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/drugItem/manage/selectDrugItem`, params)
  },

  // 删除药品
  deleteDrugIteam(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/drugItem/manage/deleteDrugItem`, params)
  },

  // 更新药品状态
  updateDrugStatus(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/drugItem/manage/updateStatus`, params)
  },

  // 更新药品数量
  updateDrugCount(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/drugItem/manage/updateItemStoreCount`, params)
  },

  // 获取开方医院
  getRequestHospital(params = {}) {
    // params.appCode = base.appCode
    params.organOnOffs = [1, 2]
    params.serviceCode = ''
    return postJsonRequest(`${base.baseUrl}/cloud/doctorbasedata/organ_distance`, params)
  },

  // 获取药店端权限
  getStoreAuth() {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/auth/manage/v1/getAuthListByStore`)
  },

  // 获取药商用户列表
  getDrugsUserList(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/pharmaceuticalCompany/manage/v1/pharmace/paginglist`, params)
  },

  // 获取药商用户详情
  getDrugsUserInfo(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/pharmaceuticalCompany/manage/v1/pharmace/detail`, params)
  },

  // 批量-导入药房
  importQuestion(params = {}) {
    return postJsonRequest(`${base.baseUrl}/prescription/sr/api/drugStore/insertBatchStoreByExcel`, params)
  },

  // 药店导入模板下载
  downloadTemplate(params = {}) {
    return blobGetRequest(`${base.baseUrl}/prescription/sr/api/drugStore/downloadTemplate`, params)
  },

  // 药店导入失败内容下载
  downloadFailedExcel(params = {}) {
    return blobGetRequest(`${base.baseUrl}/prescription/sr/api/drugStore/downloadFailedExcel`, params)
  },

  // 新增药商药品相关接口
  // 获取药品列表
  getYsDrugList(params = {}) {
    params.query.appCode = base.appCode
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/drugItem/list`, params)
  },
  // 查询药品详情
  getYsDrugDetail(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/drugItem/detail`, params)
  },
  // 获取医院药品库列表
  hospitalGetDragList(params = {}) {
    return postRequest(`${base.baseUrl}/${cloud}/api/drugItem/hospitalDrugItemList`, params);
  },
  // 确认同步医院药品
  syncHospitalDrug(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/drugItem/syncHospitalDrug`, params);
  },
  // 医院药品关联列表
  pageList(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/hospitalDrugReg/pageList`, params);
  },
  // 自动关联
  ZDRelevancy(params = {}) {
    return postRequest(`${base.baseUrl}/${cloud}/api/hospitalDrugReg/ZDRelevancy`, params);
  },
  // 手动关联校验
  SDRelevancyCheck(params = {}) {
    return postRequest(`${base.baseUrl}/${cloud}/api/hospitalDrugReg/SDRelevancyCheck`, params);
  },
  // 手动关联第二次弹框校验
  SDRelevancy(params = {}) {
    return postRequest(`${base.baseUrl}/${cloud}/api/hospitalDrugReg/SDRelevancy`, params);
  },
  // 更新药品状态
  updateYsDrugStatus(params = {}) {
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/drugItem/batchUpdateStatus`, params)
  },
  // 保存药品
  saveYsDrugIteam(params = {}) {
    params.appCode = 'JDZDSRM'
    return postJsonRequest(`${base.baseUrl}/${cloud}/api/drugItem/saveOrUpdate`, params)
  },
  // 下载导药模板
  downloadImportDrugTemplate(params = {}) {
    return blobGetRequest(`${base.baseUrl}/JDZDSRM/medicalcloud/api/manage/drugItem/js/downloadImportDrugTemplate`, params);
  },
  //  医院药品库导药接口上传文件
  hospitalImportFileUpload(params = {}) {
    const appCode = Array.from(params.entries())[1][1]
    return blobJsonRequest(`${base.baseUrl}/${appCode}/medicalcloud/api/manage/drugItem/js/import`, params);
  },
}

export default PHARMACYMANAGE



// WEBPACK FOOTER //
// ./src/api/modules/pharmacyManage.js